import Vue from 'vue';
import axios from 'axios';

export default {
  async getClientsProfitStatsXslx(clientIds, from, to, methods) {
    return await axios({
      url: '/api/stats/profit/xlsx',
      method: 'POST',
      data: { clientIds, from, to, methods },
      responseType: 'blob'
    })
  },
  async getClientsProfitStats(clientIds, from, to, methods) {
    return (await Vue.http.post('/api/stats/profit', { clientIds, from, to, methods })).data
  },
  async getClientProfitStats(clientId, from, to, methods) {
    return (await Vue.http.post(`/api/stats/clients/${clientId}/profit`, { from, to, methods })).data;
  },
  async getGamesStats(clientId, from, to) {
    return (await Vue.http.post(`/api/stats/clients/${clientId}/games`, { from, to })).data;
  },
  async getTaxesStats(clientId, from, to, gameCategories, gameProviders, currency) {
    return (await Vue.http.post(`/api/stats/clients/${clientId}/taxes`, { from, to, gameCategories, gameProviders, currency })).data;
  },
  async getPlayerStats(clientId) {
    return (await Vue.http.post(`/api/stats/clients/${clientId}/players`)).data;
  }
}



// WEBPACK FOOTER //
// ./src/services/stats.service.js